// drillout.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface DrillOutRow {
    id: string;
    padSite: string;
    wellSite: string;
    wellSiteWithNumber: string;
    startDateTime: Date
}

@Injectable({ providedIn: 'root' })
export class DrilloutFilterService {
    constructor(private http: HttpClient) { }

    getAll(): Observable<DrillOutRow[]> {
        var result = this.http.get<any>('api/drill-out/template/by-customer').pipe(
            map(res => (res ?? []) as DrillOutRow[])
        );
        return result;
    }

    getDistinctPads(): Observable<{ id: string; name: string }[]> {
        return this.getAll().pipe(
            map(rows => {
                const m = new Map<string, string>();
                rows.forEach(r => {
                    if (r.padSite && !m.has(r.padSite)) m.set(r.padSite, r.padSite);
                });
                return Array.from(m, ([id, name]) => ({ id, name }));
            })
        );
    }
}
